import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { AuthContext } from '../App';
import Sidebar from '../components/Sidebar';
import './ListStyles.css';
import './QuotationStyles.css';

const API = 'https://cctvapi.shopkwality.in/api';

const CategoryList = () => {
  const { token } = useContext(AuthContext);
  const [categories, setCategories] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API}/categories`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const categoryData = res.data?.data || res.data;
        setCategories(Array.isArray(categoryData) ? categoryData : []);
      } catch (err) {
        console.error('Failed to load categories:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchCategories();
  }, [token]);

  const filteredCategories = categories.filter(cat =>
    (cat.name || '').toLowerCase().includes(search.trim().toLowerCase())
  );

  return (
    <div className="dashboard-layout">
      <Sidebar />
      <div className="dashboard-main">
        <div className="page-header-quotation">
          <div className="container">
            <h1 className="page-title">Category List</h1>
            <p className="page-subtitle">Manage categories and open edit pages</p>
          </div>
        </div>

        <div className="container">
          <div className="list-toolbar">
            <div className="list-helper">
              {filteredCategories.length} category{filteredCategories.length === 1 ? '' : 's'}
            </div>
            <div className="list-actions">
              <Link to="/categories/new" className="btn btn-primary">
                Add Category
              </Link>
            </div>
          </div>

          <div className="list-filters">
            <input
              type="text"
              placeholder="Search categories"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="list-search-input"
            />
          </div>

          {loading ? (
            <div className="loading-container">
              <div className="spinner large"></div>
              <p>Loading categories...</p>
            </div>
          ) : filteredCategories.length === 0 ? (
            <div className="empty-state">
              <div className="empty-icon">No Data</div>
              <div className="empty-text">No categories found</div>
              <div className="empty-subtext">Try adjusting your search</div>
            </div>
          ) : (
            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Description</th>
                    <th>ID</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredCategories.map(cat => (
                    <tr key={cat.id}>
                      <td className="list-item-name">{cat.name}</td>
                      <td>{cat.description || '-'}</td>
                      <td>{cat.id}</td>
                      <td>
                        <div className="list-row-actions">
                          <Link to={`/categories/${cat.id}/edit`} className="btn btn-secondary btn-sm">
                            Edit
                          </Link>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryList;
